export enum PatientTypeEnum {
  INDIVIDUAL = 'individual',
  GROUP = 'group',
}
